import React from 'react';
import { SemanticTone } from '../../types/DesignSystem/tone';
import { AlertTriangle, CheckCircle, CrossCircle, InfoCircle, IconProps } from './Iconography/Icons';

/**
 * Tone → glyph. Shared by `Toast` and `Alert`.
 *
 * **The glyph is shared; the ink is not.** A toast sits on white and a banner sits on
 * its own tint, and the same colour does not clear 4.5:1 on both — `grey-600` is the
 * documented tertiary-text floor at 4.52:1 on white and measures **3.75–4.19:1** on
 * the five tint grounds. So each component keeps its own ink map with its own measured
 * numbers, and only the shapes live here.
 *
 * **Why shapes must differ at all:** WCAG SC 1.4.1 forbids colour as the only carrier
 * of meaning. `neutral` and `info` deliberately share `InfoCircle` — they differ in
 * urgency, not in kind — while success, warning and danger are each distinct.
 */
export const TONE_GLYPH: Record<SemanticTone, React.FC<IconProps>> = {
  neutral: InfoCircle,
  info: InfoCircle,
  success: CheckCircle,
  warning: AlertTriangle,
  danger: CrossCircle,
};
